import React, {useCallback} from "react";
import {Modal} from "@mui/material";
import {isEqual} from "lodash";
import {useViewController} from "data/services/locator/locator_hook.service";
import {IModalsController} from "views/controllers/modals/modals.controller";
import {ModalType} from "data/enums";
import {observer} from "mobx-react";
import {Bindings} from "data/constants/bindings";
import {
	CloseBtn,
	ModalBody,
	ModalBox,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalText,
	ModalTitle,
} from "views/components/modals/common/common.component";
import {ReactComponent as IconInfo} from "assets/img/icon/icon-info-gold.svg";
import {ReactComponent as IconClose} from "assets/img/icon/close.svg";
import {PrimaryButton, SecondaryButton} from "views/components/style";
import {BASE_URL, LOCAL_STORAGE_PICK_KEY} from "data/constants";

export const LosePicks: React.FC = observer(() => {
	const controller = useViewController<IModalsController>(Bindings.ModalsController);
	const {i18n, visibleModal, close} = controller;
	const isVisible = isEqual(visibleModal, ModalType.LOSE_PICKS);

	const closeWithClear = useCallback(() => {
		close();
		localStorage.removeItem(LOCAL_STORAGE_PICK_KEY);
	}, [close]);

	if (!isVisible) {
		return null;
	}

	const title = i18n.t("pinpoint.modal.lose_picks.title", "Don’t lose your predictions");
	const message = i18n.t(
		"pinpoint.modal.lose_picks.description",
		"To save your predictions and be in with a chance to win a Ryder Cup Store Voucher and Signed Pin Flag you need to have an account. Please log in or register below"
	);

	return (
		<Modal open={isVisible} onClose={closeWithClear}>
			<ModalBox>
				<ModalContent>
					<ModalHeader>
						<IconInfo />
					</ModalHeader>
					<ModalBody>
						<ModalTitle>{title}</ModalTitle>
						<ModalText>{message}</ModalText>
					</ModalBody>
					<CloseBtn onClick={closeWithClear}>
						<IconClose />
					</CloseBtn>
					<ModalFooter>
						<SecondaryButton
							fullWidth
							onClick={close}
							href={`${BASE_URL}/login`}
							variant="contained"
							size="large">
							{i18n.t("page.login.login_copy", "Log In")}
						</SecondaryButton>
						<PrimaryButton
							onClick={close}
							href={`${BASE_URL}/registration`}
							fullWidth
							variant="contained"
							size="large"
							style={{maxWidth: "320px"}}>
							{i18n.t("page.register.button_register", "Register")}
						</PrimaryButton>
					</ModalFooter>
				</ModalContent>
			</ModalBox>
		</Modal>
	);
});
